import styled from 'styled-components';

export const TopButton = styled.div`
    width:40px,
    height:40px,
    background-color:black

`;
